// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /* ::ng-deep .customer-table .mat-table {
      background-color: transparent !important;
      overflow: auto;
      display: block;
  } */
}
:host .toolbox-column {
  z-index: 1000;
  position: absolute;
  right: 10px;
  top: 40px;
}
:host .toolbox-column button {
  /* margin-right: 8px; */
  margin-left: 10px;
}
:host .toolbox-row {
  z-index: 1000;
  position: absolute;
  left: 0px;
  bottom: -50px;
}
:host .toolbox-row button {
  /* margin-right: 8px; */
  margin-left: 10px;
}
:host .data-table-header {
  min-height: 0px;
  /* background-color: darkgray; */
}
:host .column-options {
  margin-left: 10px;
  margin-right: 20px;
}
:host .data-table-edit-row {
  max-width: 40px;
  min-width: 40px;
  width: 40px;
  height: 40px;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: -24px;
}
:host .data-table-cell {
  white-space: nowrap;
  overflow: hidden;
}
:host .variable-input {
  display: block;
  margin-top: 10px;
}
:host .table-menu-item {
  font-size: 14px;
}

::ng-deep .table-menu-item .mat-icon {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-table/table-customizer/table-customizer.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/html-table/table-customizer/table-customizer.component.scss"],"names":[],"mappings":"AAAA;EACI;;;;KAAA;ACKJ;ADCI;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;ACCR;ADEI;EACI,uBAAA;EACA,iBAAA;ACAR;ADGI;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;ACDR;ADII;EACI,uBAAA;EACA,iBAAA;ACFR;ADKI;EACI,eAAA;EACA,gCAAA;ACHR;ADMI;EACI,iBAAA;EACA,kBAAA;ACJR;ADOI;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ACLR;ADQI;EACI,mBAAA;EACA,gBAAA;ACNR;ADSI;EACI,cAAA;EACA,gBAAA;ACPR;ADUI;EACI,eAAA;ACRR;;ADWA;EACI,eAAA;ACRJ","sourcesContent":[":host {\n    /* ::ng-deep .customer-table .mat-table {\n        background-color: transparent !important;\n        overflow: auto;\n        display: block;\n    } */\n\n    .toolbox-column {\n        z-index: 1000;\n        position: absolute;\n        right: 10px;\n        top: 40px;\n    }\n\n    .toolbox-column button {\n        /* margin-right: 8px; */\n        margin-left: 10px;\n    }\n\n    .toolbox-row {\n        z-index: 1000;\n        position: absolute;\n        left: 0px;\n        bottom: -50px;\n    }\n\n    .toolbox-row button {\n        /* margin-right: 8px; */\n        margin-left: 10px;\n    }\n\n    .data-table-header {\n        min-height: 0px;\n        /* background-color: darkgray; */\n    }\n\n    .column-options {\n        margin-left: 10px;\n        margin-right: 20px;\n    }\n\n    .data-table-edit-row {\n        max-width: 40px;\n        min-width: 40px;\n        width: 40px;\n        height: 40px;\n        padding-left: 0px;\n        padding-right: 0px;\n        margin-left: -24px;\n    }\n\n    .data-table-cell {\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    .variable-input {\n        display: block;\n        margin-top: 10px;\n    }\n\n    .table-menu-item {\n        font-size: 14px;\n    }\n}\n::ng-deep .table-menu-item .mat-icon {\n    font-size: 20px;\n}",":host {\n  /* ::ng-deep .customer-table .mat-table {\n      background-color: transparent !important;\n      overflow: auto;\n      display: block;\n  } */\n}\n:host .toolbox-column {\n  z-index: 1000;\n  position: absolute;\n  right: 10px;\n  top: 40px;\n}\n:host .toolbox-column button {\n  /* margin-right: 8px; */\n  margin-left: 10px;\n}\n:host .toolbox-row {\n  z-index: 1000;\n  position: absolute;\n  left: 0px;\n  bottom: -50px;\n}\n:host .toolbox-row button {\n  /* margin-right: 8px; */\n  margin-left: 10px;\n}\n:host .data-table-header {\n  min-height: 0px;\n  /* background-color: darkgray; */\n}\n:host .column-options {\n  margin-left: 10px;\n  margin-right: 20px;\n}\n:host .data-table-edit-row {\n  max-width: 40px;\n  min-width: 40px;\n  width: 40px;\n  height: 40px;\n  padding-left: 0px;\n  padding-right: 0px;\n  margin-left: -24px;\n}\n:host .data-table-cell {\n  white-space: nowrap;\n  overflow: hidden;\n}\n:host .variable-input {\n  display: block;\n  margin-top: 10px;\n}\n:host .table-menu-item {\n  font-size: 14px;\n}\n\n::ng-deep .table-menu-item .mat-icon {\n  font-size: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
